import LogInterface from ".";

export const logInterfaceRoutes = [
  {
    path: "/log-interface",
    element: <LogInterface />,
  },
];
